import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { useTheme } from '@mui/material';

export const Exercise = () => {
  const theme = useTheme();

  return (
    <FitnessCenterIcon
      fontSize="large"
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
